import React from "react";
import EduFooterOne from "../common/footer/EduFooterOne";
import HeaderTwo from "../common/header/HeaderTwo";
import SEO from "../common/SEO";
import BannerTwooo from "../component/banner/BannerThree";
import BannerTwo from "../component/banner/BannerTwo";
import CounterUpOne from "../component/counterup/CounterUpOne";
import EduPropOne from "../component/service/EduPropOne";
import TestimonialEdu from "../component/testimonial/TestimonialEdu";
import SectionTitle from "../elements/section-title/SectionTitle";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SplashCta from "../component/cta/SplashCta";
import HomeHero from "../component/homehero/homehero";
import ProjectOne from "../component/project/ProjectOne";
import AutoPopup from "../component/homehero/Autopopup";

const CreativeAgency = () => {
  return (
    <>
      <SEO title="Education" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderTwo />
        <BannerTwooo />
        <HomeHero />
        <div className="row">
          <ProjectOne colSize="col-xl-4 col-md-6" itemShow="17" />
        </div>
        <CounterUpOne />
        <TestimonialEdu />
        <BannerTwo />
        <SplashCta />
        <EduFooterOne parentClass="" />
        <AutoPopup/>
      </main>
    </>
  );
};

export default CreativeAgency;
